import type { MedioPagoPos } from './tipos'

/**
 * El medio de pago con el que abre el cobro.
 *
 * Era «el primero de la lista», y eso no es una decisión: es una consecuencia
 * del orden. En una verdulería la enorme mayoría de las ventas son en efectivo,
 * y el efectivo es el único que suma al cajón, así que el día que el local
 * agrega una billetera con un orden más bajo el cajero apurado cobra con el
 * medio equivocado y el arqueo del turno queda mal **sin que nada falle**: la
 * venta sale bien igual, y el faltante aparece recién al cerrar.
 *
 * Ahora lo decide el local (`porDefectoPos`, editable desde Configuración) y
 * esta función es la única que lo resuelve, para que los dos diálogos de cobro
 * no puedan discrepar.
 *
 * Dos reglas más, en este orden:
 *
 * - **El fiado nunca viene preseleccionado**, ni siquiera si alguien lo marcó
 *   en la base por otra vía: obliga a elegir cliente, así que cada venta
 *   arrancaría pidiendo a quién anotarla, y si el cajero cobra sin mirar, la
 *   mercadería se va sin plata y a la cuenta de nadie. El servidor también lo
 *   rechaza; acá se vuelve a filtrar porque el catálogo de la caja puede venir
 *   de una bajada vieja.
 * - **Si el local no eligió ninguno**, se cae al primero que no sea fiado. Es
 *   el comportamiento de antes, y es lo que corresponde mientras la caja no
 *   haya bajado todavía la marca.
 */
export function medioPorDefecto(medios: MedioPagoPos[]): MedioPagoPos | null {
  const cobrables = medios.filter((m) => !m.esCuentaCorriente)

  return cobrables.find((m) => m.porDefectoPos === true) ?? cobrables[0] ?? null
}
